export default "__VITE_ASSET__C2c3FxyW__"